import {parse} from "graphql"
import _fieldDirectiveFinder from "./_fieldDirectiveFinder";

export default ({typeDefs}) => {
    const defaultFieldsMap = {}
    typeDefs = _fieldDirectiveFinder(typeDefs)((directive, field, model) => {
        if (directive.name.value === 'requires') {
            const fieldsList = directive.arguments.find(({name: {value}}) => value === 'fields').value.value;
            const fieldsDefinitions = parse(`{ ${fieldsList} }`).definitions[0].selectionSet.selections;
            const converter = (selections, acc) => {
                selections.forEach(s => {
                    acc[s.name.value] = s.selectionSet ? {select: converter(s.selectionSet.selections, {})} : true;
                });
                return acc;
            }
            defaultFieldsMap[model.name.value] = defaultFieldsMap[model.name.value] || {}
            defaultFieldsMap[model.name.value][field.name.value] = converter(fieldsDefinitions, {});
            return true;
        }
    })
    return {typeDefs, defaultFieldsMap};
}
